import { Box, Button, Paper } from '@mui/material';
import React, { useEffect, useState } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Colors from '../../Constant/Colors';
import client from '../../API/client';
import moment from 'moment/moment';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const DesignerNotification = () => {
  const [notification, setNotification] = useState([]);

  useEffect(() => {
    getNotification();
  }, []);

  const getNotification = async () => {
    try {
      await client
        .get('/designer/dashboard/get-notification')
        .then((res) => {
          console.log(res.data);
          setNotification(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Box m="20px">
        {/* <Alert severity="error">Oops!! Something went Wrong</Alert> */}
        <ToastContainer />
        <Paper
          elevation={4}
          style={{ padding: '20px', height: '660px', overflow: 'scroll' }}>
          {notification.map((data) => (
            <List
              sx={{
                width: '100%',
                maxWidth: '80%',
                bgcolor: 'background.paper',
              }}>
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar alt="N" src="/static/images/avatar/1.jpg" />
                </ListItemAvatar>
                <ListItemText
                  secondary={
                    <React.Fragment>
                      <h5>Job Post</h5>
                      <Typography
                        sx={{ display: 'inline' }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        <span
                          style={{
                            color: Colors.darkpurple,
                            fontWeight: '500',
                          }}>
                          {data.postedby}
                        </span>{' '}
                        has posted a job for <b>{data.title}</b>
                      </Typography>
                    </React.Fragment>
                  }
                />
                <div style={{ color: 'green', marginTop: '4px' }}>
                  {moment(data.createdat).fromNow()}
                </div>
              </ListItem>
              <Divider variant="inset" component="li" />
            </List>
          ))}
        </Paper>
      </Box>
    </>
  );
};
